import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DXONgSwiftUiModule } from '@dxo/ng-swift-ui';
import Components from './components';
import { DynamicComponentHostDirective } from './directives/dynamic-component-host/dynamic-component-host.directive';
import { BillingPeriodToStringPipe } from '@benefitsui/app/shared/pipes/billingPeriod/billingPeriodToStringPipe';

@NgModule({
  declarations: [Components, DynamicComponentHostDirective, BillingPeriodToStringPipe],
  imports: [CommonModule, DXONgSwiftUiModule],
  exports: [Components, DynamicComponentHostDirective, BillingPeriodToStringPipe]
})
export class BenefitsSharedModule {}
